import React from "react";
import { useStyleDisplay } from "../helpers/useStyleDisplay";
import useTimerShow from "../../../hook/useTimerShow";

export default function DoctorQueueDisplayDateTime() {
    const classsDisplay = useStyleDisplay();
    const DateTime = useTimerShow();
    return (
        <div>
            <h3 className={`${classsDisplay.headTextTime} text-white mb-0 text-center text-xl-left`}>{`${
                DateTime.days
            }/${DateTime.months}/${DateTime.years} ${DateTime.hours}:${DateTime.minutes}:${
                DateTime.seconds.length < 2 ? "0" + DateTime.seconds : DateTime.seconds
            }`}</h3>
        </div>
    );
}
